export default {"src":"/_next/static/media/yandex.115ab65b.svg","height":985,"width":2500,"blurWidth":0,"blurHeight":0};